import {useIntl} from 'react-intl'
import {MessageList, MessageListForwardRef} from './MessageList'
import {CollapsibleText} from '../../../../../_gori/partials/widgets'
import {useEffect, useRef, useState} from 'react'
import {MESSAGE_CONTAINER_ID} from '../../definitions'
import {ChatbotHeader} from './ChatbotHeader'

type ChatbotWidgetProps = {
  onHide: () => void
}
export const ChatbotWidget = ({onHide}: ChatbotWidgetProps) => {
  const intl = useIntl()
  const messagesRef = useRef<MessageListForwardRef>(null)
  const refreshTimerId = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [loading, setLoading] = useState(false)

  const onRefresh = async (withLoading = true) => {
    if (withLoading) {
      setLoading(true)
    }
    await messagesRef?.current?.getMessages()
    const container = document.getElementById(MESSAGE_CONTAINER_ID)
    if (container) {
      refreshTimerId.current = setTimeout(() => {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth',
        })
      }, 100)
    }
    if (withLoading) {
      setLoading(false)
    }
  }
  useEffect(() => {
    return () => clearTimeout(refreshTimerId.current as NodeJS.Timeout)
  }, [])

  return (
    <div className='d-flex flex-column h-100'>
      <ChatbotHeader
        loading={loading}
        onRefresh={(withLoading) => onRefresh(withLoading)}
        onHide={onHide}
      />
      <CollapsibleText
        text={intl.formatMessage({id: 'WELCOME_WARNING_MESSAGE'})}
        className='px-3 py-4 warning-message fs-8'
      />
      <MessageList ref={messagesRef} />
    </div>
  )
}
